<template>
  <!-- 审批规则记录 -->
  <div class="record-list">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button @click="_exportCreditHistory" type="primary">
          下载
        </a-button>
      </div>
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        @handlePagination="handlePagination"
        row-key="key"
        :scroll="{
          x: 1300,
        }"
      ></table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { CREDIT_TYPE_OBJ } from './const'
import {
  getRecordList,
  exportCreditHistory,
  getBusinessList,
  getModelList,
} from './api'
//import { formatParamDate } from 'utils/util'

export default {
  name: 'record-list',
  data() {
    const initSearchForm = {
      pid: '',
      id: '',
    }
    const searchForm = cloneDeep(initSearchForm)

    return {
      // SEARCH_SCHEMA,
      SEARCH_SCHEMA: [
        {
          itemName: 'pid',
          label: '业务类型',
          type: 'select',
          selectList: [],
          handleChange: this.changeBusiness,
        },
        {
          itemName: 'id',
          label: '业务模式',
          type: 'select',
          selectList: [],
        },
      ],
      CREDIT_TYPE_OBJ,
      initSearchForm,
      searchForm,
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableLoading: false,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          fixed: 'left',
        },
        {
          title: '业务类型',
          dataIndex: 'business',
          // width: 120
        },
        {
          title: '业务模式',
          dataIndex: 'model',
          width: 120,
        },
        {
          title: '信用五级（单位/万元）',
          dataIndex: 'credit5',
          width: 200,
        },
        {
          title: '信用四级（单位/万元）',
          dataIndex: 'credit4',
          width: 200,
        },
        {
          title: '信用三级（单位/万元）',
          dataIndex: 'credit3',
          width: 200,
        },
        {
          title: '信用二级（单位/万元）',
          dataIndex: 'credit2',
          width: 200,
        },
        {
          title: '信用一级（单位/万元）',
          dataIndex: 'credit1',
          width: 200,
        },
      ],
    }
  },
  mounted() {
    this._getRecordList(this.initSearchForm), this._getBusinessList()
  },
  methods: {
    async _getBusinessList() {
      const { data } = await getBusinessList()
      if (data) {
        const selectList = data.map(item => ({
          text: item.name,
          value: item.id,
        }))
        this.SEARCH_SCHEMA[0].selectList = selectList
      }
    },
    async changeBusiness(value) {
      // this.initSearchForm.setFieldsValue({ modelId: '' })
      try {
        const { data } = await getModelList({ pid: value, type: 3 })
        if (data) {
          const selectList = data.map(item => ({
            text: item.name,
            value: item.id,
          }))
          this.SEARCH_SCHEMA[1].selectList = selectList
        } else {
          this.SEARCH_SCHEMA[1].selectList = []
        }
      } catch (err) {
        console.log(err)
      }
    },
    async _getRecordList(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ruleType: 1,
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getRecordList(formData)
        this.pageData.total = total
        this.tableData = records.map((item, index) => {
          item.key = `${index}`
          return item
        })
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch(data) {
      // data = formatParamDate(
      //   data,
      //   data.applyRangeDate,
      //   'applyStart',
      //   'applyEnd'
      // )
      // data = formatParamDate(
      //   data,
      //   data.approveRangeDate,
      //   'approveStart',
      //   'approveEnd'
      // )
      // delete data.applyRangeDate
      // delete data.approveRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getRecordList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getRecordList(this.searchForm)
    },
    handleView(row) {
      const { id, type, status } = row
      this.$router.push({
        path: `/credit-approval/apply-detail/${id}`,
        query: {
          type,
          status,
        },
      })
    },
    _exportCreditHistory() {
      const data = {
        ruleType: 1,
        pid: this.initSearchForm.pid,
        id: this.initSearchForm.id,
      }
      exportCreditHistory(data)
    },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
